import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

// Rename together with PDP_LAYOUT_REVAMP_FLAG in consumer's config/postHogConstants.js
export const PDP_LAYOUT_REVAMP_FLAG = 'pdp-layout-revamp';

// test-a: revamp layout only; test-b: revamp layout and gallery
export const PDP_LAYOUT_REVAMP_VARIANTS = {
  CONTROL: 'control',
  TEST_A: 'test-a',
  TEST_B: 'test-b'
};

// No key on ineligible pages: any read counts as an exposure
const usePDPLayoutRevampTestVariant = isEligible => {
  return usePostHogFeatureFlag(isEligible ? PDP_LAYOUT_REVAMP_FLAG : null);
};
export default usePDPLayoutRevampTestVariant;